export const sensorsSorting = (sensors, menu) => {
    let AOS = require("aos");
    const sensorsTable = document.querySelector(sensors);
    const dropdownMenu = document.querySelector(menu);

    if (sensorsTable) {
        const allTypes = sensorsTable.querySelectorAll('.c-sensor-type--all');
        const allSone = sensorsTable.querySelectorAll('.c-sensor-type--sone');
        const allDsw = sensorsTable.querySelectorAll('.c-sensor-type--dsw');

        const hideAll = () => {
            allTypes.forEach((item) => {
                item.classList.add('hide');
            });
        }

        const showType = (type) => {
            if ('c-sensor-type--sone' === type) {
                allSone.forEach((item) => {
                    item.classList.remove('hide');
                });
            }

            if ('c-sensor-type--dsw' === type) {
                allDsw.forEach((item) => {
                    item.classList.remove('hide');
                });
            }

            if ('c-sensor-type--all' === type) {
                allTypes.forEach((item) => {
                    item.classList.remove('hide');
                });
            }
        }

        const setCurrentChoose = (label) => {
            const dropdownButton = dropdownMenu.parentElement.querySelector('.c-dropdown__button');

            if (dropdownButton) {
                dropdownButton.innerHTML = label;
            }
        }

        const getUrlParameter = (name) => {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(name);
        }

        const applyFilterFromUrl = () => {
            const selectedSensorType = getUrlParameter('selectedSensorType');
            if (selectedSensorType) {
                hideAll();
                showType(selectedSensorType);

                const selectedItem = dropdownMenu.querySelector(`#${selectedSensorType}`);
                if (selectedItem) {
                    setCurrentChoose(selectedItem.innerHTML);
                }
            }
        }

        // Attach event listeners to each dropdown item
        if (dropdownMenu) {
            const dropdownItems = dropdownMenu.querySelectorAll('.dropdown-item');

            dropdownItems.forEach((item) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    const currentType = item.id;
                    const selectedUrl = item.getAttribute('data-url');

                    hideAll();
                    showType(currentType);
                    setCurrentChoose(item.innerHTML);
                    const newUrl = new URL(window.location.href);
                    newUrl.searchParams.set('selectedSensorType', currentType);
                    window.history.pushState({}, '', newUrl);

                    AOS.refresh();
                });
            });
        }

        applyFilterFromUrl();
    }
}
